import * as React from 'react';
import { IconClose12 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IProps {
  onClick(): void;
}

export function Close({ onClick }: IProps) {
  return (
    <div className={styles['container']} onClick={onClick}>
      <IconClose12 />
    </div>
  );
}
